import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { capitalize } from 'lodash'

import { observer } from 'mobx-react'

import { UserSelectorInput } from 'modules/core/components/Inputs/UserSelector'
import Loading from 'modules/core/components/Loading'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import { actions } from 'modules/automations/store/collections/actions'
import { Action } from 'modules/automations/store/models/Action'
import type { Automation } from 'modules/automations/store/models/Automation'

interface SelectorProps {
  action: Action
  user: User
}

const UserSelector = ({ action, user }: SelectorProps) => {
  const [selectedIds, setSelectedIds] = React.useState([user.attributes.id])

  const { performAction: submit } = useAsyncAction(() =>
    action.save({
      metadata: {
        access_id: selectedIds[0],
      },
    })
  )

  const onSelect = (userIds: number[]) => setSelectedIds(userIds)
  const selectedId = selectedIds[0]

  return (
    <>
      <Box paddingTop="s12">
        <UserSelectorInput
          none
          label={capitalize(i18n.t('expenses.settings.approval.approval_responsible'))}
          multiselect={false}
          onSubmit={onSelect}
          selectedIds={selectedIds}
          users={users.models}
        />
      </Box>
      {user.attributes.id !== selectedId && (
        <Box paddingTop="s32">
          <Button onClick={submit}>
            {capitalize(i18n.t('expenses.settings.approval.submit'))}
          </Button>
        </Box>
      )}
    </>
  )
}

interface Props {
  automation: Automation
}

const Content = ({ automation }: Props) => {
  const { loading } = useUnsafeAsyncData(
    () =>
      actions.fetch({
        data: {
          automations_automation_id: automation.attributes.id,
        },
      }),
    [automation]
  )

  const action = actions.find({
    automations_automation_id: automation.attributes.id,
    actionable_type: Action.Types.requestReview,
  })

  if (!action) return null

  const user = users.find({
    id: action.metadata.access_id,
  })

  if (!user) return null

  return (
    <Box>
      {!!loading && <Loading />}
      {!loading && !!user && (
        <Box>
          <Text.Normal>{i18n.t('expenses.settings.approval.description_2')}</Text.Normal>
          <UserSelector action={action} user={user} />
        </Box>
      )}
    </Box>
  )
}

export default observer(Content)
